import React from 'react';
import {OpportunityStatus} from '../../models/opportunity';

interface OpportunityStatusFilterProps {
  selectedStatus: OpportunityStatus | null;
  onStatusChange: (status: OpportunityStatus) => void;
}

export const OpportunityStatusFilter: React.FC<OpportunityStatusFilterProps> = ({selectedStatus, onStatusChange}) => {
  const filters = [
    {status: OpportunityStatus.PUBLISHED, label: 'Active'},
    {status: OpportunityStatus.DRAFT, label: 'Draft'},
    {status: OpportunityStatus.CLOSED, label: 'Closed'},
  ];

  return (
    <div className="flex gap-2">
      {filters.map(({status, label}) => (
        <button
          key={status}
          onClick={() => onStatusChange(status)}
          className={`px-6 py-2 text-sm font-medium rounded-full transition-all duration-200 ${
            selectedStatus === status
              ? 'bg-blue-500 text-white shadow-md'
              : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
          }`}>
          {label}
        </button>
      ))}
    </div>
  );
};
